import React, { useState } from "react";
import Styles from "../styles/UsersList.module.css";
import { userAPI } from "../services/api";

const UserContainer = ({ user, handleDelete, index }) => {
  const [role, setRole] = useState(user.role || "user");
  const [saving, setSaving] = useState(false);

  const saveRole = async () => {
    setSaving(true);
    try {
      await userAPI.setUserRole(user.id, role);
    } catch (error) {
      window.alert(error.message || "Failed to update role");
      setRole(user.role || "user");
    } finally {
      setSaving(false);
    }
  };

  return (
    <tr key={user.id}>
      <td>{index + 1}</td>
      <td>{user.username}</td>
      <td>{user.id}</td>
      <td>{user.email}</td>
      <td>
        <select
          value={role}
          onChange={(event) => setRole(event.target.value)}
          disabled={saving}
        >
          <option value="user">User</option>
          <option value="manager">Manager</option>
          <option value="admin">Admin</option>
        </select>
        <button
          className={Styles.delete_button}
          onClick={saveRole}
          disabled={saving || role === (user.role || "user")}
        >
          {saving ? "Saving..." : "Save Role"}
        </button>
      </td>
      <td>
        <button
          className={Styles.delete_button}
          onClick={() => handleDelete(user.id)}
        >
          Delete
        </button>
      </td>
    </tr>
  );
};

export default UserContainer;
